// ============================================
// AI Chat 설정 및 상수 — Agent 방식
// ============================================

const AGENT_MODEL = 'gpt-5.4-mini';
const FAST_MODEL = 'gpt-5.4-mini';

export const AI_MODELS = {
  AGENT_MODEL,
  FAST_MODEL,
  TITLE_MODEL: FAST_MODEL,
  SUMMARY_MODEL: FAST_MODEL,
};

// 일부 reasoning 모델(예: gpt-5.5)은 temperature default(1)만 허용 — 모델별 capability 분기
// 호출 측: `...buildTemperatureParam(MODEL, 0.1)` spread로 사용
export function buildTemperatureParam(model, defaultTemp) {
  if (model?.startsWith('gpt-5.5')) return {};
  return { temperature: defaultTemp };
}

export const MAX_OUTPUT_TOKENS = 15000;

export const INITIAL_SESSION_SUMMARY = '- 사용자는 관리자';
export const DEFAULT_RESPONSE = '무엇을 도와드릴까요?';
export const RESPONSE_FAILED_RETRY = '지금은 답변이 어려워요. 잠시 후 다시 시도해주세요.';
export const CANCELLED_RESPONSE = '요청을 중단했어요. 다시 질문해주시면 바로 확인해드릴게요!';

export const TOOL_CALLING_LOG = process.env.NODE_ENV === 'development'; // 자동 환경 분기

// 앱 비즈니스 컨텍스트: 기본 국가/지역 (전화번호 등 region-specific 형식 처리용) //
// 향후 다국가 확장 시 사용자 설정/백엔드 메타에서 override 가능 //
export const APP_REGION = process.env.REACT_APP_REGION || 'KR';

export const SECRET_KEY = 'LinkOpenAI2024SecretKey32Byte!';
export const GCM_IV_LENGTH = 12;

export const ERROR_CONFIG = {
  OPENAI_TIMEOUT:       { retryable: true,  maxRetries: 2, message: '앗, 제가 너무 바빠서 확인을 못했어요 😅 다시 해볼게요!' },
  OPENAI_RATE_LIMIT:    { retryable: true,  maxRetries: 3, message: '지금 요청이 좀 많아요! 잠깐만 기다려주세요 🙏' },
  OPENAI_CONTEXT_LIMIT: { retryable: true,  maxRetries: 1, shouldSummarize: true, message: '대화가 길어져서 정리하고 올게요! ✨' },
  OPENAI_SERVER_ERROR:  { retryable: true,  maxRetries: 2, message: '앗, 잠깐 실수했어요 😅 다시 해볼게요!' },
  BACKEND_TIMEOUT:      { retryable: true,  maxRetries: 2, message: '확인하는 데 시간이 좀 걸리고 있어요 ⏳ 조금만 기다려주세요!' },
  BACKEND_AUTH_ERROR:   { retryable: false, maxRetries: 0, message: '로그인 정보가 만료됐어요 😢 새로고침 한 번 해주세요!' },
  BACKEND_PERMISSION_ERROR: { retryable: false, maxRetries: 0, message: '이 정보는 조회 권한이 없어서 확인해드릴 수 없어요 🔒' },
  BACKEND_NOT_FOUND:    { retryable: false, maxRetries: 0, message: '찾으려는 데이터가 없는 것 같아요 🤔' },
  BACKEND_NETWORK_ERROR:{ retryable: true,  maxRetries: 2, message: '앗, 제가 너무 바빠서 확인을 못했어요 😅 다시 시도해볼게요!' },
};

export const FALLBACK_MESSAGES = {
  LEVEL_1: '앗, 잠깐 실수했어요 😅 다시 말씀해주시겠어요?',
  LEVEL_2: '계속 헤매고 있네요 😢 다시 물어봐주시면 더 잘할 수 있어요!',
  LEVEL_3: '지금 좀 컨디션이 안 좋아요 😵 새로고침을 해주세요!',
};
